import { render, staticRenderFns } from "./RentalCar.vue?vue&type=template&id=7caffa71&"
import script from "./RentalCar.vue?vue&type=script&lang=js&"
export * from "./RentalCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports